/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkQuestionRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkQuestionRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkQuestionRequest>): WellArchitectedFrameworkQuestionRequest {
        let obj = Object.assign(new WellArchitectedFrameworkQuestionRequest(), model);
        WellArchitectedFrameworkQuestionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkQuestionRequest>): WellArchitectedFrameworkQuestionRequest {
        if (!model) return null;
        return WellArchitectedFrameworkQuestionRequest.newInstance(<WellArchitectedFrameworkQuestionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkQuestionRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkQuestionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkQuestionRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkQuestionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.questions) {
            for (let val of this.questions) {
                models.WellArchitectedFrameworkQuestion.fixupPrototype(val);
            }
        }
    }

    /**
     * Questions to process
     */
    questions: Array<models.WellArchitectedFrameworkQuestion>;

}
